import React from 'react';

/**
 * Optical Rx mark used wherever the prescription question comes up. Drawn in
 * SVG so it stays sharp and needs no external asset. Deliberately a generic
 * optical/Rx symbol rather than any association's logo, which would imply an
 * endorsement we do not have.
 */
export function RxMark({
  className = 'h-9 w-9'
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 48 48" role="img" aria-label="Prescription" className={className} focusable="false" data-id="element-1120" data-mp="2f51fd5qew5z2">
      <circle cx="24" cy="24" r="23" fill="#0E7C86" data-id="element-1121" data-mp="219z3m1yvvmec" />
      <circle cx="24" cy="24" r="20" fill="none" stroke="#ffffff" strokeWidth="1.5" opacity="0.65" data-id="element-1122" data-mp="263bn5xoph308" />
      <text x="24" y="31" textAnchor="middle" fill="#ffffff" fontFamily="Georgia, Times New Roman, serif" fontSize="22" fontWeight="700" data-id="element-1123" data-mp="1reynoqqet20z">
        Rx
      </text>
    </svg>;
}

/**
 * Mobile counterpart to the Rx badge: a full-width strip that sits right under
 * the artwork, where the answer to "can I use my prescription?" has to be
 * visible before anyone scrolls.
 */
export function PrescriptionStrip({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center justify-center gap-3 border-b border-[#0E7C86]/70 bg-[#07242a] px-4 py-3 lg:hidden ${className}`} data-id="element-1124" data-mp="39ijglo0y92fq">
      <RxMark className="h-8 w-8 shrink-0" data-id="element-1125" data-mp="3jed3a08ducb8" />
      <p className="text-left" data-id="element-1126" data-mp="3jcjtwd6dxdzj">
        <span className="block font-display text-lg font-extrabold uppercase leading-none text-[#7fe3ec]" data-id="element-1127" data-mp="2vosgt7d0swx7">
          Prescription ready
        </span>
        <span className="mt-0.5 block text-[13px] font-medium text-steel-200" data-id="element-1128" data-mp="2qrii113qr8wp">
          Your vision. Your prescription. Your X1.
        </span>
      </p>
    </div>;
}
interface PrescriptionBadgeProps {
  className?: string;
  /** Compact variant for tight cards. */
  compact?: boolean;
}
export function PrescriptionBadge({
  className = '',
  compact = false
}: PrescriptionBadgeProps) {
  return <div className={`flex items-center gap-3 border border-[#0E7C86]/70 bg-[#07242a] px-4 py-3 ${className}`} data-id="element-1129" data-mp="27yy4cqwm5adh">
      <RxMark className={compact ? 'h-9 w-9 shrink-0' : 'h-11 w-11 shrink-0'} data-id="element-1130" data-mp="2xlsi1u4v9t2s" />
      <p className="min-w-0" data-id="element-1131" data-mp="31ndsz9xubxac">
        <span className={`block font-display font-extrabold uppercase leading-tight tracking-wide text-[#7fe3ec] ${compact ? 'text-base' : 'text-lg sm:text-xl'}`} data-id="element-1132" data-mp="36fx29uphw69c">
          Prescription ready
        </span>
        <span className="mt-0.5 block text-[13px] font-medium leading-relaxed text-steel-300" data-id="element-1133" data-mp="2eq2cjwxq6ek5">
          Wear prescription lenses? Take your X1 to your trusted optical professional and ask about a custom
          prescription setup.
        </span>
      </p>
    </div>;
}